<template>
  <div class="quick-text-message">
    <span v-for="(item, index) in data.text" :key="index">
      <template v-if="index === 0">
        <span
          v-if="
            ['teacher', 'assistant'].includes(USER_ROLE_NAME[msgItem.userRole])
          "
          class="role-tag"
          >{{ USER_ROLE[msgItem.userRole] }}</span
        >
        <span class="nick-name"
          >{{ msgItem.nickname }}
          <span
            v-if="
              msgItem.cloudCustomData &&
              msgItem.cloudCustomData.isPrivateMsg === 1
            "
          >
            对我<span style="color: #94bfff">(私聊)</span>
          </span>
          ：
        </span>
      </template>
      <a v-if="isUrl(item.text)" :href="item.text" target="_blank">{{
        item.text
      }}</a>
      <span
        v-else-if="item.name === 'text'"
        class="text-content"
        :style="{ color: msgItem.payload.textColor || '#fff' }"
        >{{ item.text }}</span
      >
      <img v-else-if="item.name === 'img'" class="text-img" :src="item.src" />
    </span>
  </div>
</template>

<script>
import {
  USER_ROLE,
  USER_ROLE_NAME,
} from "@saas/live-sdk/src/services/utils/constants.js";
export default {
  name: "MsgText",
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    msgItem: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      USER_ROLE,
      USER_ROLE_NAME,
    };
  },
  methods: {
    // 判断一个字符串是否是链接
    isUrl(str) {
      return /^(https?|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/.test(
        str
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.quick-text-message {
  font-weight: 500;
  font-size: 12px;
  color: #ffffff;
  line-height: 15px;
  display: -webkit-box; /* 启用flexbox布局 */
  -webkit-box-orient: vertical; /* 垂直方向排列 */
  -webkit-line-clamp: 3; /* 限制显示三行 */
  overflow: hidden; /* 隐藏溢出内容 */
  text-overflow: ellipsis; /* 显示省略号 */
  word-break: break-word; /* 允许在长单词或URL内部换行 */

  a {
    color: #386bff;
  }
  .text-img {
    width: 17px; /* 调整表情图片大小 */
    height: 17px; /* 调整表情图片大小 */
    vertical-align: middle; /* 使图片与文字对齐 */
    display: inline-block; /* 确保图片是行内块，方便与文本对齐 */
  }
  .text-content {
    display: inline; /* 确保文本内容是行内元素 */
  }
  .role-tag {
    width: max-content;
    background: #052814;
    border-radius: 8px;
    height: 15px;
    padding: 0 4px;
    font-weight: 500;
    font-size: 11px;
    color: #17c964;
    line-height: 15px;
    display: inline-block; /* 确保角色标签是行内块 */
    margin-right: 4px; /* 添加一些右边距 */
    flex-shrink: 0; /* 防止被压缩 */
  }
  .nick-name {
    display: inline; /* 确保昵称是行内元素 */
  }
}
</style>
